import { Appconfig } from './../interface/appconfig';
import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class AppconfigService {

  static settings: Appconfig;

  static clgcode: string;

  static regno: string;

  static clgname: string;

  static mobileno: string;

  static studentcount: string;

  static otpstatus = false;

  constructor(private http: HttpClient) {}

  load() {
    return new Promise<void>((resolve, reject) => {
      const jsonFile = `assets/config/config.json`;
      this.http.get(jsonFile).subscribe(data => {
        AppconfigService.settings = <Appconfig>data;
        resolve();
       },
  error => {reject(error); });
    });
  }
}
